var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll{position:absolute;bottom:0;width:100%;overflow-y:auto;top:0;padding-bottom:.5rem;background:#eff2f5}.scroll.from-query{top:2.2rem}.scroll.to-tab{bottom:2.25rem}.scroll.to-bottom-btn{bottom:1.2rem}.scroll.bg-white{background-color:#fff}.scroll.from-query-more{top:4rem}.net-warning-pic{background:url(" + escape(require("../../static/img/net-error.png")) + ") no-repeat top;background-size:2.96rem 2.96rem;margin:3rem auto 0;width:100%}.net-warning-text{font-size:.48rem;text-align:center;height:2rem;line-height:2rem;padding-top:6rem}.net-warning-tips{font-size:.346667rem;text-align:center;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77a12b68","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Scroll.vue
// module id = 473
// module chunks = 0